// This file is generated by pnpm icons:generate. Do not edit.

import {CloseQuote_Stroke2_Corner0_Rounded as CanonicalCloseQuote_Stroke2_Corner0_Rounded} from './CloseQuote'
import {CloseQuote_Stroke2_Corner1_Rounded as CanonicalCloseQuote_Stroke2_Corner1_Rounded} from './CloseQuote'

/** @deprecated Import CloseQuote_Stroke2_Corner0_Rounded from `#/components/icons/CloseQuote` instead. */
export const CloseQuote_Stroke2_Corner0_Rounded =
  CanonicalCloseQuote_Stroke2_Corner0_Rounded

/** @deprecated Import CloseQuote_Stroke2_Corner1_Rounded from `#/components/icons/CloseQuote` instead. */
export const CloseQuote_Stroke2_Corner1_Rounded =
  CanonicalCloseQuote_Stroke2_Corner1_Rounded
